import { imageUrl } from '@helpers/image';
import { asSlug } from '@helpers/slug';
import * as React from 'react';
import S from './ApproachCard.styles';
const ApproachCard = ({ image, summary, target, title, url }) => {
    const titleId = asSlug(title);
    return (React.createElement(S.Container, null,
        React.createElement(S.Link, { as: url ? 'a' : 'div', ...(url && { href: url, target }), "aria-disabled": !url },
            React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { alt: image.altText?.trim() || `${title} icon`, src: imageUrl(image, { width: 720, height: 452 }), loading: "lazy" })),
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.Title, { "$isLink": !!url, id: titleId }, title),
                React.createElement(S.Summary, { dangerouslySetInnerHTML: { __html: summary } })))));
};
export default ApproachCard;
